// extracted by mini-css-extract-plugin
export default {"sort":"VB-z","sortSelect":"WB-z","disabled":"XB-z"};